module.exports = __webpack_public_path__ + "48d4c9e93ecff8af3e1f1b61359a4f9c.pdf";